
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collab-block-staking",
      function () {
        return require("private-next-pages/collab-block-staking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collab-block-staking"])
      });
    }
  